module.exports = __webpack_public_path__ + "static/USRetailGiant-image-51d9b1355775d9825299a24bb5e7b6e5.png";